import React, { useState, useEffect } from 'react';
import OrderCard from './OrderCard';
import SkeletonCard from './SkeletonCard';
import Spinner from './Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons'; // นำเข้าไอคอนที่ต้องการ

const OrderList = ({ orders, username, onOrderUpdate, shouldRemoveOnUpdate }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (orders.length > 0) {
            setIsLoading(false); // ปิดการโหลดเมื่อมีข้อมูลแล้ว
        } else {
            setIsLoading(false); // ตรวจสอบให้แน่ใจว่าโหลดอยู่เมื่อยังไม่มีข้อมูล
        }
    }, [orders]);

    return (
        <div className="board-container">
            {isLoading ? (
                <div className="loading-container">
                    <Spinner />
                    {Array.from({ length: 5 }).map((_, index) => (
                        <SkeletonCard key={index} />
                    ))}
                </div>
            ) : (
                orders.length > 0 ? (
                    orders.map((order) => (
                        <OrderCard 
                            key={order.id} 
                            order={order} 
                            username={username} 
                            onOrderUpdate={onOrderUpdate} 
                            shouldRemoveOnUpdate={shouldRemoveOnUpdate} // ส่งค่าให้กับ OrderCard
                        />
                    ))
                ) : (
                    <div className="no-orders-message-container">
                        <FontAwesomeIcon icon={faXmark} className="no-orders-icon no-orders-paper" />
                        <p className="no-orders-message">งานวันนี้ไม่มีแล้ว</p>
                    </div>
                )
            )}
        </div>
    );
};


export default OrderList;
